import {
  combineReducers,
} from 'redux';
import extendedReducer from './configurator';
import product from './product';
import productInfo from './productInfo';
import cart from './cart';
import skuMap from './skuMap';
import recommendations from './recommendations';
import storeSearch from './storeSearch';
import gallery from './gallery';
import config from './config';
import thdStoreInfo from './thdStoreInfo';
import pricing from './pricing';
import deliveryInfo from './deliveryInfo';
import canonicalUrl from './canonicalUrl';
import favorite from './favorite';
import choiceAndSkuAvailability from './choiceAndSkuAvailability';
import choiceInit from './choiceInit';
import earliestDeliveryInfo from './earliestDeliveryInfo';
import harmony from './harmony';
import pageMetaOverview from './pageMeta';
import {
  hydrationReducer,
} from './hydrationReducer';

const rootReducer = combineReducers({
  configurator: extendedReducer,
  product,
  productInfo,
  cart,
  skuMap,
  recommendations,
  storeSearch,
  gallery,
  config,
  thdStoreInfo,
  pricing,
  deliveryInfo,
  canonicalUrl,
  favorite,
  choiceAndSkuAvailability,
  choiceInit,
  earliestDeliveryInfo,
  hydration: hydrationReducer,
  harmony,
  pageMetaOverview
});

export default rootReducer;
